import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import {
  updateTcRequest,
  updateTcRequestSuccess,
  updateTcRequestError,
} from "../../../slices/teams/members/UpdateTcSlice";

export const UpdateTc = (data) => async (dispatch) => {
  try {
    dispatch(updateTcRequest());

    const response = await axiosInstance.put(endpoints.updateTc, data, {
      headers: { "Content-Type": "application/json" },
    });

    dispatch(updateTcRequestSuccess(response.data));
    return response.data;
  } catch (error) {
    const _error = {
      data: error?.response?.data?.message || error?.message,
      status: error?.response?.status || error?.status,
    };
    dispatch(updateTcRequestError(_error));
    throw _error;
  }
};
